const services = [
  {
    icon: 'ri-plant-line',
    title: 'Mulching',
    description: 'Professional mulch installation to enhance your landscape beauty and protect your plants year-round.'
  },
  {
    icon: 'ri-scissors-cut-line',
    title: 'Lawn Mowing',
    description: 'Regular, reliable lawn mowing services to keep your grass perfectly manicured and healthy.'
  },
  {
    icon: 'ri-leaf-line',
    title: 'Fall & Spring Cleanups',
    description: 'Seasonal yard cleanups to prepare your property for changing weather and maintain curb appeal.'
  },
  {
    icon: 'ri-home-gear-line',
    title: 'Gutter Cleaning',
    description: 'Thorough gutter cleaning to prevent water damage and ensure proper drainage around your property.'
  },
  {
    icon: 'ri-hammer-line',
    title: 'Hardscaping',
    description: 'Custom hardscape design and installation including patios, retaining walls, and outdoor living spaces.'
  },
  {
    icon: 'ri-paint-brush-line',
    title: 'Paint Jobs',
    description: 'Professional exterior painting services to refresh and protect your property structures.'
  },
  {
    icon: 'ri-water-flash-line',
    title: 'Drainage Solutions',
    description: 'Expert drainage system installation to prevent flooding and protect your landscape investment.'
  },
  {
    icon: 'ri-contrast-drop-2-line',
    title: 'Pressure Washing',
    description: 'High-quality pressure washing for driveways, walkways, decks, and building exteriors.'
  },
  {
    icon: 'ri-road-map-line',
    title: 'Concrete Work',
    description: 'Professional concrete driveways, walkways, and sidewalks - repairs and new installations.'
  },
  {
    icon: 'ri-snowy-line',
    title: 'Snow Removal',
    description: 'Reliable snow removal services to keep your property safe and accessible during winter.'
  },
  {
    icon: 'ri-temp-cold-line',
    title: 'Ice Management',
    description: 'Professional ice control and de-icing to prevent slips and maintain safe walkways.'
  },
  {
    icon: 'ri-seedling-line',
    title: 'Yard Restorations',
    description: 'Complete yard restoration services to revive damaged or neglected landscapes.'
  },
  {
    icon: 'ri-tree-line',
    title: 'Tree & Bush Trimming',
    description: 'Expert tree and shrub trimming to maintain healthy growth and beautiful shapes.'
  }
];

export function Services() {
  const scrollToContact = () => {
    const element = document.getElementById('contact');
    if (element) {
      const offset = 80;
      const elementPosition = element.getBoundingClientRect().top;
      const offsetPosition = elementPosition + window.pageYOffset - offset;
      window.scrollTo({
        top: offsetPosition,
        behavior: 'smooth'
      });
    }
  };

  return (
    <section id="services" className="py-20 bg-white">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="mb-16">
          <div className="flex items-center gap-2 mb-4">
            <div className="w-2 h-2 bg-[#4A7C2C] rounded-full"></div>
            <p className="text-[#4A7C2C] font-semibold text-sm uppercase tracking-wider">Our Services</p>
          </div>
          <h2 className="text-4xl md:text-5xl font-bold text-gray-900 mb-4">
            Complete Landscaping Solutions
          </h2>
          <p className="text-lg text-gray-600 max-w-3xl">
            From routine maintenance to major installations, we offer comprehensive landscaping services to meet all your residential and commercial needs in Owings Mills and surrounding areas.
          </p>
        </div>

        <div className="grid sm:grid-cols-2 lg:grid-cols-3 gap-8">
          {services.map((service, index) => (
            <div 
              key={index}
              className="bg-white rounded-2xl p-8 border border-gray-100 hover:shadow-xl transition-all duration-300 hover:-translate-y-2 group cursor-pointer"
            >
              <div className="w-16 h-16 bg-[#4A7C2C] rounded-full flex items-center justify-center mb-6 group-hover:scale-110 transition-transform duration-300">
                <i className={`${service.icon} text-3xl text-white`}></i>
              </div>
              <h3 className="text-xl font-bold text-gray-900 mb-3">{service.title}</h3>
              <p className="text-gray-600 mb-4 leading-relaxed">{service.description}</p>
              <button 
                onClick={scrollToContact}
                className="text-[#4A7C2C] font-semibold flex items-center gap-2 group-hover:gap-3 transition-all whitespace-nowrap cursor-pointer"
              >
                Learn More
                <i className="ri-arrow-right-line"></i>
              </button>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
